import React, { useReducer, useEffect, useState } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Container,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Table,
} from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { defaultState } from "./store/store";

import style from "./CorpEvents.module.scss";
import { EventSimpleReducer } from "./store/reducer";
import { Combobox, Field } from "../Order/Field/Field";
import CircularProgress from "../../CircularProgress/CircularProgress";
import GridCustody from "./Items/GridCustody";
import GridAccount from "./Items/GridAccount";
import Errors from "./Items/Error";
import { Numeric } from "../../Modal/Order/Field/Field";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { DateField } from "../../../utils";
import { parseDate } from "../../../utils/dateUtils";
import { showToast } from "../../../utils/Helper";
import translate from "../../../utils/Translator";


const CorpEvents = ({ open, toggle, newE, toggleEvent, searchEvents, services, isEventReviewer, isReviewer, isReadOnly, ...props }) => {
  const [state, dispatch] = useReducer(EventSimpleReducer, defaultState());
  const [Corpevent, setEvent] = useState({});
  const [custodyProp, setCustodyProp] = useState([]);
  const [custody, setCustody] = useState([]);
  const [account, setAccount] = useState([]);
  const [accountProp, setAccountProp] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [auxaccount, setAccountAux] = useState([]);
  const [custodyaux, setCustodyAux] = useState([]);
  const [wizzard, setWizzard] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errorbook, seterrorbook] = useState({ open: false, desc: "" });
  const [label, setLabel] = useState("");
  const [sending, setSending] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [downloading, setdownloading] = useState(false);
  const [currencypairs, setCurrencyPairs] = useState({
    labelsett: "",
    labelcomm: "",
    labeltax: "",
  });
  const [isFundsXSystem, setIsFundsXSystem] = useState(false);

  const [ChangesValuesInCustodians, setChangesValuesInCustodians] = useState(false);
  const [OriginalCustodiansValues, setOriginalCustodiansValues] = useState({});
  const [OriginalClientsValues, setOriginalClientsValues] = useState({});
  const [ChangesValuesInClients, setChangesValuesInClients] = useState(false);
  const [LastUpdatedFrom, setLastUpdatedFrom] = useState("");

  const [FirstChangeClients, setFirstChangeClients] = useState(true);
  const [revertingStatus, setRevertingStatus] = useState(false);
  const [confirmRevertOpen, setConfirmRevertOpen] = useState(false);
  const [revertText, setRevertText] = useState("");
  const [FirstChangeCustodians, setFirstChangeCustodians] = useState(true);

  useEffect(() => {
    if (props.event.CorporateEventId !== 0) {
      services
        .fetchGetCorporateEventSingle({
          corporateeventid: props.event.CorporateEventId,
        })
        .then((r) => {
          console.log(r)
          setEvent(r);
          const custodyProp1 = r.Account.filter((account) => account.IsProp);
          const custody1 = r.Account.filter((account) => !account.IsProp);
          const account1 = r.Account.filter((account) => !account.IsProp);
          const accountProp1 = r.Account.filter((account) => account.IsProp);

          let custodyProp = custodyProp1.filter((item) => item.BasicAccountType == "Bank");
          let custody = custody1.filter((item) => item.BasicAccountType == "Bank");
          let account = account1.filter((item) => item.BasicAccountType == "Customer");
          let accountProp = accountProp1.filter(
            (item) => item.BasicAccountType == "InBalance" || item.BasicAccountType == "Fund"
          );

          let item = account.length > 0 && JSON.parse(JSON.stringify(account[0]));
          if (!item) {
            item = accountProp.length > 0 && JSON.parse(JSON.stringify(accountProp[0]));
          }

          if (item) {
            item.EventAccountAmount = 0;
            for (let i = 0; i < item.FootPrintCredit.length; i++) {
              item.FootPrintCredit[i].EventAccountDebitCreditVolume = 0;
            }

            for (let i = 0; i < item.FootPrintDebit.length; i++) {
              item.FootPrintDebit[i].EventAccountDebitCreditVolume = 0;
            }
          }

          let item2 = custody.length > 0 && JSON.parse(JSON.stringify(custody[0]));
          if (!item2) {
            item2 = custodyProp.length > 0 && JSON.parse(JSON.stringify(custodyProp[0]));
          }

          if (item2) {
            item2.EventAccountAmount = 0;

            for (let i = 0; i < item2.FootPrintCredit.length; i++) {
              item2.FootPrintCredit[i].EventAccountDebitCreditVolume = 0;
            }

            for (let i = 0; i < item2.FootPrintDebit.length; i++) {
              item2.FootPrintDebit[i].EventAccountDebitCreditVolume = 0;
            }
          }

          setCustody(custody);
          setCustodyProp(custodyProp);
          setAccount(account);
          setAccountProp(accountProp);
          setAccountAux(item);
          setCustodyAux(item2);
          setEvent(r);
          setOriginalCustodiansValues({
            BaseNoProp: r.BaseNoProp,
            BaseProp: r.BaseProp,
            CorporateEventFX: r.CorporateEventFX,
            CorporateEventCommissionFX: r.CorporateEventCommissionFX,
            CorporateEventTaxFX: r.CorporateEventTaxFX,
            CorporateEventClientTaxFX: r.CorporateEventClientTaxFX,
            CorporateEventSettlementCurrency: r.CorporateEventSettlementCurrency,
            CorporateEventCommissionCurrency: r.CorporateEventCommissionCurrency,
            CorporateEventTaxCurrency: r.CorporateEventTaxCurrency,
            WithholdingNoProp: r.WithholdingNoProp,
            WithholdingProp: r.WithholdingProp,
            FeeNoProp: r.FeeNoProp,
            FeeProp: r.FeeProp,
            TaxNoProp: r.TaxNoProp,
            TaxProp: r.TaxProp,
            BookDate: r.BookDate,
            CommissionNoPropClient: r.CommissionNoPropClient,
            CommissionProp: r.CommissionProp,
          });
          setOriginalClientsValues({
            BaseNoProp: r.BaseNoProp,
            BaseProp: r.BaseProp,
            CorporateEventFX: r.CorporateEventFX,
            CorporateEventCommissionFX: r.CorporateEventCommissionFX,
            CorporateEventTaxFX: r.CorporateEventTaxFX,
            CorporateEventClientTaxFX: r.CorporateEventClientTaxFX,
            CorporateEventSettlementCurrency: r.CorporateEventSettlementCurrency,
            CorporateEventCommissionCurrency: r.CorporateEventCommissionCurrency,
            CorporateEventTaxCurrency: r.CorporateEventTaxCurrency,
            WithholdingNoProp: r.WithholdingNoProp,
            WithholdingProp: r.WithholdingProp,
            FeeNoProp: r.FeeNoProp,
            FeeProp: r.FeeProp,
            TaxNoProp: r.TaxNoProp,
            TaxProp: r.TaxProp,
            BookDate: r.BookDate,
            CommissionNoPropClient: r.CommissionNoPropClient,
            CommissionProp: r.CommissionProp,
          });
          setFirstChangeClients(false);
          setFirstChangeCustodians(false);
        });
    }
  }, [props.event.CorporateEventId]);

  useEffect(() => {
    if (services && services.isFundManagerSistem) {
      services.isFundManagerSistem().then((res) => {
        if (res && res.response) {
          const parametersData = res.response.SdtParametersData;
          if (parametersData && parametersData.ParameterNumericValue == 1) {
            setIsFundsXSystem(true);
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    services.fetchCurrencies({}).then((r) => {
      const currency = r.currencies;
      const currencies = [];
      let item = {};
      for (let i = 0; i < currency.length; i++) {
        item = {
          id: currency[i].currencyId,
          description: currency[i].currencyISO,
        };
        currencies.push(item);
      }
      setCurrencies(currencies);
    });
  }, []);

  const onChange = (name, value) => {
    if (name == "BookDate") {
      onChangeCurrencyDate(
        "CorporateEventSettlementCurrency",
        Corpevent.CorporateEventSettlementCurrency,
        value
      );
      onChangeCurrencyDate(
        "CorporateEventCommissionCurrency",
        Corpevent.CorporateEventCommissionCurrency,
        value
      );
      onChangeCurrencyDate("CorporateEventTaxCurrency", Corpevent.CorporateEventTaxCurrency, value);

      setEvent((event) => ({
        ...event,
        [name]: value,
      }));
    } else {
      setEvent((event) => ({
        ...event,
        [name]: value,
      }));
    }
  };

  const deleteEvent = () => {
    setDeleting(true);
    services
      .fetchDeleteCorporateEvent({
        corporateeventid: props.event.CorporateEventId,
      })
      .then((r) => {
        searchEvents();
        toggle();
      });
  };

  useEffect(() => {
    if (FirstChangeCustodians) return;

    const changed =
      Number(Corpevent.BaseNoProp) !== Number(OriginalCustodiansValues.BaseNoProp) ||
      Number(Corpevent.BaseProp) !== Number(OriginalCustodiansValues.BaseProp) ||
      Number(Corpevent.CorporateEventFX) !== Number(OriginalCustodiansValues.CorporateEventFX) ||
      Number(Corpevent.CorporateEventCommissionFX) !==
        Number(OriginalCustodiansValues.CorporateEventCommissionFX) ||
      Number(Corpevent.CorporateEventTaxFX) !== Number(OriginalCustodiansValues.CorporateEventTaxFX) ||
      Number(Corpevent.CorporateEventClientTaxFX) !==
        Number(OriginalCustodiansValues.CorporateEventClientTaxFX) ||
      Corpevent.CorporateEventSettlementCurrency !==
        OriginalCustodiansValues.CorporateEventSettlementCurrency ||
      Corpevent.CorporateEventCommissionCurrency !==
        OriginalCustodiansValues.CorporateEventCommissionCurrency ||
      Corpevent.CorporateEventTaxCurrency !== OriginalCustodiansValues.CorporateEventTaxCurrency ||
      Number(Corpevent.WithholdingNoProp) !== Number(OriginalCustodiansValues.WithholdingNoProp) ||
      Number(Corpevent.WithholdingProp) !== Number(OriginalCustodiansValues.WithholdingProp) ||
      Number(Corpevent.FeeNoProp) !== Number(OriginalCustodiansValues.FeeNoProp) ||
      Number(Corpevent.FeeProp) !== Number(OriginalCustodiansValues.FeeProp) ||
      Number(Corpevent.TaxNoProp) !== Number(OriginalCustodiansValues.TaxNoProp) ||
      Number(Corpevent.TaxProp) !== Number(OriginalCustodiansValues.TaxProp) ||
      Corpevent.BookDate !== OriginalCustodiansValues.BookDate ||
      Number(Corpevent.CommissionNoPropClient) !== Number(OriginalCustodiansValues.CommissionNoPropClient) ||
      Number(Corpevent.CommissionProp) !== Number(OriginalCustodiansValues.CommissionProp);

    setChangesValuesInCustodians(changed);
    if (!changed) setLastUpdatedFrom("");
  }, [Corpevent, OriginalCustodiansValues, FirstChangeCustodians]);

  useEffect(() => {
    if (FirstChangeClients) return;

    const changed =
      Number(Corpevent.BaseNoProp) !== Number(OriginalClientsValues.BaseNoProp) ||
      Number(Corpevent.BaseProp) !== Number(OriginalClientsValues.BaseProp) ||
      Number(Corpevent.CorporateEventFX) !== Number(OriginalClientsValues.CorporateEventFX) ||
      Number(Corpevent.CorporateEventCommissionFX) !==
        Number(OriginalClientsValues.CorporateEventCommissionFX) ||
      Number(Corpevent.CorporateEventTaxFX) !== Number(OriginalClientsValues.CorporateEventTaxFX) ||
      Number(Corpevent.CorporateEventClientTaxFX) !==
        Number(OriginalClientsValues.CorporateEventClientTaxFX) ||
      Corpevent.CorporateEventSettlementCurrency !== OriginalClientsValues.CorporateEventSettlementCurrency ||
      Corpevent.CorporateEventCommissionCurrency !== OriginalClientsValues.CorporateEventCommissionCurrency ||
      Corpevent.CorporateEventTaxCurrency !== OriginalClientsValues.CorporateEventTaxCurrency ||
      Number(Corpevent.WithholdingNoProp) !== Number(OriginalClientsValues.WithholdingNoProp) ||
      Number(Corpevent.WithholdingProp) !== Number(OriginalClientsValues.WithholdingProp) ||
      Number(Corpevent.FeeNoProp) !== Number(OriginalClientsValues.FeeNoProp) ||
      Number(Corpevent.FeeProp) !== Number(OriginalClientsValues.FeeProp) ||
      Number(Corpevent.TaxNoProp) !== Number(OriginalClientsValues.TaxNoProp) ||
      Number(Corpevent.TaxProp) !== Number(OriginalClientsValues.TaxProp) ||
      Corpevent.BookDate !== OriginalClientsValues.BookDate ||
      Number(Corpevent.CommissionNoPropClient) !== Number(OriginalClientsValues.CommissionNoPropClient) ||
      Number(Corpevent.CommissionProp) !== Number(OriginalClientsValues.CommissionProp);

    setChangesValuesInClients(changed);
    if (!changed) setLastUpdatedFrom("");
  }, [Corpevent, OriginalClientsValues, FirstChangeClients]);

  const onChangeGrid = (cd, cp, prop, accountnum, index, value) => {
    let name = "";
    let total = 0;
    if (cd === "Account") {
      if (value.AccountId !== null) {
        if (cp === "Client") {
          if (prop) {
            accountProp[accountnum].BasicAccountId = value.AccountId;
            accountProp[accountnum].BasicAccountName = value.AccountName;
            accountProp[accountnum].BasicAccountNumber = value.AccountNumber;
          } else {
            account[accountnum].BasicAccountId = value.AccountId;
            account[accountnum].BasicAccountName = value.AccountName;
            account[accountnum].BasicAccountNumber = value.AccountNumber;
          }
        } else if (cp === "CustodyCash") {
          if (prop) {
            custodyProp[accountnum].EventCashCustAccountId = value.AccountId;
            custodyProp[accountnum].EventCashCustAccountName = value.AccountName;
          } else {
            custody[accountnum].EventCashCustAccountId = value.AccountId;
            custody[accountnum].EventCashCustAccountName = value.AccountName;
          }
        } else {
          if (prop) {
            custodyProp[accountnum].BasicAccountId = value.AccountId;
            custodyProp[accountnum].BasicAccountName = value.AccountName;
            //custodyProp[accountnum].BasicAccountType = value.BasicAccountType
          } else {
            custody[accountnum].BasicAccountId = value.AccountId;
            custody[accountnum].BasicAccountName = value.AccountName;
            //custody[accountnum].BasicAccountType = value.BasicAccountType
          }
        }
      }
    } else {
      if (cd === "EventAccountAmount") {
        if (cp === "Client") {
          if (prop) {
            total =
              Number(Corpevent.PortfolioTotalPropClient) -
              Number(accountProp[accountnum].EventAccountAmount) +
              Number(value);
            accountProp[accountnum].EventAccountAmount = value;
            name = "PortfolioTotalPropClient";
          } else {
            total =
              Number(Corpevent.PortfolioTotalNoPropClient) -
              Number(account[accountnum].EventAccountAmount) +
              Number(value);
            account[accountnum].EventAccountAmount = value;
            name = "PortfolioTotalNoPropClient";
          }
        } else {
          if (prop) {
            total =
              Number(Corpevent.PortfolioTotalProp) -
              Number(custodyProp[accountnum].EventAccountAmount) +
              Number(value);
            custodyProp[accountnum].EventAccountAmount = value;
            name = "PortfolioTotalProp";
          } else {
            total =
              Number(Corpevent.PortfolioTotalNoProp) -
              Number(custody[accountnum].EventAccountAmount) +
              Number(value);
            custody[accountnum].EventAccountAmount = value;
            name = "PortfolioTotalNoProp";
          }
        }
        setEvent((Corpevent) => ({
          ...Corpevent,
          [name]: total,
        }));
      } else {
        if (Number(value) >= 0) {
          if (prop) {
            if (cp === "Client") {
              if (cd === "Debit") {
                if (accountProp[accountnum].FootPrintDebit[index].EventAccountIsWithholding) {
                  name = "WithholdingPropClient";
                  total =
                    Number(Corpevent.WithholdingPropClient) -
                    Number(accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }
                if (accountProp[accountnum].FootPrintDebit[index].EventAccountIsCommission) {
                  name = "CommissionPropClient";
                  total =
                    Number(Corpevent.CommissionPropClient) -
                    Number(accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintDebit[index].EventAccountIsTax) {
                  name = "TaxPropClient";
                  total =
                    Number(Corpevent.TaxPropClient) -
                    Number(accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintDebit[index].EventAccountIsFee) {
                  name = "FeePropClient";
                  total =
                    Number(Corpevent.FeePropClient) -
                    Number(accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintDebit[index].EventAccountBaseForTax) {
                  name = "BasePropClient";
                  total =
                    Number(Corpevent.BasePropClient) -
                    Number(accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                accountProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume = value;
                accountProp[accountnum].FootPrintDebit[index].EventAccountModified = true;
              } else {
                if (accountProp[accountnum].FootPrintCredit[index].EventAccountIsWithholding) {
                  name = "WithholdingPropClient";
                  total =
                    Number(Corpevent.WithholdingPropClient) -
                    Number(accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }
                if (accountProp[accountnum].FootPrintCredit[index].EventAccountIsCommission) {
                  name = "CommissionPropClient";
                  total =
                    Number(Corpevent.CommissionPropClient) -
                    Number(accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintCredit[index].EventAccountIsTax) {
                  name = "TaxPropClient";
                  total =
                    Number(Corpevent.TaxPropClient) -
                    Number(accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintCredit[index].EventAccountIsFee) {
                  name = "FeePropClient";
                  total =
                    Number(Corpevent.FeePropClient) -
                    Number(accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (accountProp[accountnum].FootPrintCredit[index].EventAccountBaseForTax) {
                  name = "BasePropClient";
                  total =
                    Number(Corpevent.BasePropClient) -
                    Number(accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }
                accountProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume = value;
                accountProp[accountnum].FootPrintCredit[index].EventAccountModified = true;
              }
            } else {
              if (cd == "Debit") {
                if (custodyProp[accountnum].FootPrintDebit[index].EventAccountIsWithholding) {
                  name = "WithholdingProp";
                  total =
                    Number(Corpevent.WithholdingProp) -
                    Number(custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintDebit[index].EventAccountIsCommission) {
                  name = "CommissionProp";
                  total =
                    Number(Corpevent.CommissionProp) -
                    Number(custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (
                  custodyProp[accountnum].FootPrintDebit[index].EventAccountTicker === "UYU TAX (Executed)"
                ) {
                  name = "TaxProp";
                  total =
                    Number(Corpevent.TaxProp) -
                    Number(custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintDebit[index].EventAccountIsFee) {
                  name = "FeeProp";
                  total =
                    Number(Corpevent.FeeProp) -
                    Number(custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintDebit[index].EventAccountBaseForTax) {
                  name = "BaseProp";
                  total =
                    Number(Corpevent.BaseProp) -
                    Number(custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                custodyProp[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume = value;
                custodyProp[accountnum].FootPrintDebit[index].EventAccountModified = true;
              } else {
                if (custodyProp[accountnum].FootPrintCredit[index].EventAccountIsWithholding) {
                  name = "WithholdingProp";
                  total =
                    Number(Corpevent.WithholdingProp) -
                    Number(custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintCredit[index].EventAccountIsCommission) {
                  name = "CommissionProp";
                  total =
                    Number(Corpevent.CommissionProp) -
                    Number(custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (
                  custodyProp[accountnum].FootPrintCredit[index].EventAccountTicker === "UYU TAX (Executed)"
                ) {
                  name = "TaxProp";
                  total =
                    Number(Corpevent.TaxProp) -
                    Number(custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintCredit[index].EventAccountIsFee) {
                  name = "FeeProp";
                  total =
                    Number(Corpevent.FeeProp) -
                    Number(custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custodyProp[accountnum].FootPrintCredit[index].EventAccountBaseForTax) {
                  name = "BaseProp";
                  total =
                    Number(Corpevent.BaseProp) -
                    Number(custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }
                custodyProp[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume = value;
                custodyProp[accountnum].FootPrintCredit[index].EventAccountModified = true;
              }
            }
          } else {
            if (cp == "Client") {
              if (cd == "Debit") {
                if (account[accountnum].FootPrintDebit[index].EventAccountIsWithholding) {
                  name = "WithholdingNoPropClient";
                  total =
                    Number(Corpevent.WithholdingNoPropClient) -
                    Number(account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintDebit[index].EventAccountIsCommission) {
                  name = "CommissionNoPropClient";
                  total =
                    Number(Corpevent.CommissionNoPropClient) -
                    Number(account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintDebit[index].EventAccountIsTax) {
                  name = "TaxNoPropClient";
                  total =
                    Number(Corpevent.TaxNoPropClient) -
                    Number(account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintDebit[index].EventAccountIsFee) {
                  name = "FeeNoPropClient";
                  total =
                    Number(Corpevent.FeeNoPropClient) -
                    Number(account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintDebit[index].EventAccountBaseForTax) {
                  name = "BaseNoPropClient";
                  total =
                    Number(Corpevent.BaseNoPropClient) -
                    Number(account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                account[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume = value;
              } else {
                if (account[accountnum].FootPrintCredit[index].EventAccountIsWithholding) {
                  name = "WithholdingNoPropClient";
                  total =
                    Number(Corpevent.WithholdingNoPropClient) -
                    Number(account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintCredit[index].EventAccountIsCommission) {
                  name = "CommissionNoPropClient";
                  total =
                    Number(Corpevent.CommissionNoPropClient) -
                    Number(account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintCredit[index].EventAccountIsTax) {
                  name = "TaxNoPropClient";
                  total =
                    Number(Corpevent.TaxNoPropClient) -
                    Number(account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintCredit[index].EventAccountIsFee) {
                  name = "FeeNoPropClient";
                  total =
                    Number(Corpevent.FeeNoPropClient) -
                    Number(account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (account[accountnum].FootPrintCredit[index].EventAccountBaseForTax) {
                  name = "BaseNoPropClient";
                  total =
                    Number(Corpevent.BaseNoPropClient) -
                    Number(account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                account[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume = value;

                account[accountnum].FootPrintCredit[index].EventAccountModified = true;
              }
            } else {
              if (cd == "Debit") {
                if (custody[accountnum].FootPrintDebit[index].EventAccountIsWithholding) {
                  name = "WithholdingNoProp";
                  total =
                    Number(Corpevent.WithholdingNoProp) -
                    Number(custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintDebit[index].EventAccountIsCommission) {
                  name = "CommissionNoProp";
                  total =
                    Number(Corpevent.CommissionNoProp) -
                    Number(custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintDebit[index].EventAccountIsTax) {
                  name = "TaxClientNoProp";
                  total =
                    Number(Corpevent.TaxClientNoProp) -
                    Number(custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintDebit[index].EventAccountIsFee) {
                  name = "FeeClientNoProp";
                  total =
                    Number(Corpevent.FeeClientNoProp) -
                    Number(custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintDebit[index].EventAccountBaseForTax) {
                  name = "BaseNoProp";
                  total =
                    Number(Corpevent.BaseNoProp) -
                    Number(custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                custody[accountnum].FootPrintDebit[index].EventAccountDebitCreditVolume = value;
              } else {
                if (custody[accountnum].FootPrintCredit[index].EventAccountIsWithholding) {
                  name = "WithholdingNoProp";
                  total =
                    Number(Corpevent.WithholdingNoProp) -
                    Number(custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintCredit[index].EventAccountIsCommission) {
                  name = "CommissionNoProp";
                  total =
                    Number(Corpevent.CommissionNoProp) -
                    Number(custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintCredit[index].EventAccountTicker === "UYU TAX (Executed)") {
                  name = "TaxNoProp";
                  total =
                    Number(Corpevent.TaxNoProp) -
                    Number(custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintCredit[index].EventAccountIsFee) {
                  name = "FeeNoProp";
                  total =
                    Number(Corpevent.FeeNoProp) -
                    Number(custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                if (custody[accountnum].FootPrintCredit[index].EventAccountBaseForTax) {
                  name = "BaseNoProp";
                  total =
                    Number(Corpevent.BaseNoProp) -
                    Number(custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume) +
                    Number(value);
                }

                custody[accountnum].FootPrintCredit[index].EventAccountDebitCreditVolume = value;
                custody[accountnum].FootPrintCredit[index].EventAccountModified = true;
              }
            }
          }
          setEvent((Corpevent) => ({
            ...Corpevent,
            [name]: total,
          }));
        } else {
          seterrorbook((errorbook) => ({
            ...errorbook,
            open: true,
            desc: "Amount should be positive",
          }));
        }
      }
    }
  };

  const onChangeCurrency = (name, value) => {
    var id = Number(value);
    let baseCurrency = Corpevent.CurrencyId;
    var p = currencies;
    let iso1 = "";

    if (name == "CorporateEventTaxCurrency") {
      for (var i = 0; i < p.length; i++) {
        if (p[i].id == Corpevent.CorporateEventSettlementCurrency) {
          iso1 = p[i].description;
          baseCurrency = Corpevent.CorporateEventSettlementCurrency;
        }
      }
    }

    let date = new Date(Date.parse(Corpevent.BookDate) - 1 * 24 * 1 * 1 * 1000).toDateLocal();

    services.fetchCurrencyFX({ baseCurrency: baseCurrency, targetCurrency: id, date: date }).then((r) => {
      var p = currencies;
      let fx = "";
      let fxclient = "";
      let price = Number(r.FX.price).toFixed(4);
      let divides = r.FX.divides;
      var id = Number(value);
      let label = "Multiply";
      let iso = "";
      for (var i = 0; i < p.length; i++) {
        if (p[i].id == value) {
          iso = p[i].description;
        }
      }

      if (divides) label = "divides";
      if (name === "CorporateEventSettlementCurrency") {
        fx = "CorporateEventFX";
        setCurrencyPairs({
          labelsett: Corpevent.CurrencyISO + "/" + iso + " " + label,
          labelcomm: currencypairs.labelcomm,
          labeltax: currencypairs.labeltax,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
          CorporateEventSettlementCurrencyISO: iso,
        }));
      }

      if (name === "CorporateEventCommissionCurrency") {
        fx = "CorporateEventCommissionFX";
        setCurrencyPairs({
          labelcomm: Corpevent.CurrencyISO + "/" + iso + " " + label,
          labelsett: currencypairs.labelsett,
          labeltax: currencypairs.labeltax,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
          CorporateEventCommissionCurrencyISO: iso,
        }));
      }

      if (name === "CorporateEventTaxCurrency") {
        fx = "CorporateEventTaxFX";
        fxclient = "CorporateEventClientTaxFX";
        setCurrencyPairs({
          labeltax: iso1 + "/" + iso + " " + label,
          labelcomm: currencypairs.labelcomm,
          labelsett: currencypairs.labelsett,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
          [fxclient]: price,
          CorporateEventTaxCurrencyISO: iso,
        }));
      }
    });
  };

  const onChangeCurrencyDate = (name, value, date) => {
    var id = Number(value);
    let baseCurrency = Corpevent.CurrencyId;
    var p = currencies;
    let iso1 = "";

    if (name == "CorporateEventTaxCurrency") {
      for (var i = 0; i < p.length; i++) {
        if (p[i].id == Corpevent.CorporateEventSettlementCurrency) {
          iso1 = p[i].description;
          baseCurrency = Corpevent.CorporateEventSettlementCurrency;
        }
      }
    }

    services.fetchCurrencyFX({ baseCurrency: baseCurrency, targetCurrency: id, date: date }).then((r) => {
      var p = currencies;
      let fx = "";
      let fxclient = "";
      let price = Number(r.FX.price).toFixed(4);
      let divides = r.FX.divides;
      var id = Number(value);
      let label = "Multiply";
      let iso = "";
      for (var i = 0; i < p.length; i++) {
        if (p[i].id == value) {
          iso = p[i].description;
        }
      }

      if (divides) label = "divides";
      if (name === "CorporateEventSettlementCurrency") {
        fx = "CorporateEventFX";
        setCurrencyPairs({
          labelsett: Corpevent.CurrencyISO + "/" + iso + " " + label,
          labelcomm: currencypairs.labelcomm,
          labeltax: currencypairs.labeltax,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
        }));
      }

      if (name === "CorporateEventCommissionCurrency") {
        fx = "CorporateEventCommissionFX";
        setCurrencyPairs({
          labelcomm: Corpevent.CurrencyISO + "/" + iso + " " + label,
          labelsett: currencypairs.labelsett,
          labeltax: currencypairs.labeltax,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
        }));
      }

      if (name === "CorporateEventTaxCurrency") {
        fx = "CorporateEventTaxFX";
        fxclient = "CorporateEventClientTaxFX";
        setCurrencyPairs({
          labeltax: iso1 + "/" + iso + " " + label,
          labelcomm: currencypairs.labelcomm,
          labelsett: currencypairs.labelsett,
        });
        setEvent((corpevent) => ({
          ...corpevent,
          [name]: id,
          [fx]: price,
          [fxclient]: price,
        }));
      }
    });
  };

  const recalculate = (i) => {
    setLoading(true);
    setWizzard(i);
    let Account = [];

    Account = [...custody];

    Account = Account.concat(account);

    Account = Account.concat(custodyProp);

    Account = Account.concat(accountProp);

    let corpevent = {
      Account,
    };

    corpevent.id = Corpevent.id;
    corpevent.AssetId = Corpevent.AssetId;
    corpevent.Date = Corpevent.Date;
    corpevent.name = Corpevent.name;
    corpevent.CorporateEventType = Corpevent.CorporateEventType;
    corpevent.CorporateEventSettlementCurrency = Corpevent.CorporateEventSettlementCurrency;
    corpevent.CorporateEventFX = Corpevent.CorporateEventFX;
    corpevent.CorporateEventCommissionCurrency = Corpevent.CorporateEventCommissionCurrency;
    corpevent.CorporateEventCommissionFX = Corpevent.CorporateEventCommissionFX;
    corpevent.CorporateEventTaxFX = Corpevent.CorporateEventTaxFX;
    corpevent.CorporateEventTaxCurrency = Corpevent.CorporateEventTaxCurrency;
    corpevent.CorporateEventClientTaxFX = Corpevent.CorporateEventClientTaxFX;
    corpevent.CorporateEventTaxPercentage = Corpevent.CorporateEventTaxPercentage;
    corpevent.BookDate = Corpevent.BookDate;
    corpevent.RecordDate = Corpevent.RecordDate;
    corpevent.CorporateEventWithholdingP = Corpevent.CorporateEventWithholdingP;

    for (var j = 0; j < corpevent.Account.length; j++) {
      let FootPrint = [];
      if (Account[j].FootPrintCredit != undefined) {
        FootPrint = [...Account[j].FootPrintCredit];
        if (Account[j].FootPrintDebit != undefined) FootPrint = FootPrint.concat(Account[j].FootPrintDebit);
      } else if (Account[j].FootPrintDebit != undefined) FootPrint = [...Account[j].FootPrintDebit];
      corpevent.Account[j].Footprint = FootPrint;
    }

    services.fetchRecalculateEvent({ corpevent }).then((re) => {
      services
        .fetchGetCorporateEventSingle({
          corporateeventid: props.event.CorporateEventId,
        })
        .then((r) => {
          //This line is to persist the BookDate
          setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));

          let custodyProp1 = r.Account.filter((account) => account.IsProp);
          let custody1 = r.Account.filter((account) => !account.IsProp);
          let account1 = r.Account.filter((account) => !account.IsProp);
          let accountProp1 = r.Account.filter((account) => account.IsProp);

          let custodyProp = custodyProp1.filter((item) => item.BasicAccountType == "Bank");
          let custody = custody1.filter((item) => item.BasicAccountType == "Bank");
          let account = account1.filter((item) => item.BasicAccountType == "Customer");
          let accountProp = accountProp1.filter(
            (item) => item.BasicAccountType == "InBalance" || item.BasicAccountType == "Fund"
          );
          setCustody(custody);
          setCustodyProp(custodyProp);
          setAccount(account);
          setAccountProp(accountProp);
          setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));
          setLoading(false);
        });
    });
    //}
  };

  const recalculateBeforeSend = () => {
    let errors = "";
    if (Corpevent.CorporateEventReleased) {
      if (Number(Corpevent.WithholdingNoProp) - Number(Corpevent.WithholdingNoPropClient) > 1) {
        errors += "WithholdingNoProp should be equal to WithholdingNoPropClient    ";
      }
      if (Number(Corpevent.WithholdingProp) - Number(Corpevent.WithholdingPropClient) > 1) {
        errors += "WithholdingProp should be equal to WithholdingPropClient    ";
      }
      if (Number(Corpevent.BaseNoProp) - Number(Corpevent.BaseNoPropClient) > 1) {
        errors += "BaseNoProp should be equal to BaseNoPropClient     ";
      }
      if (Number(Corpevent.BaseProp) - Number(Corpevent.BasePropClient) > 1) {
        errors += "BaseProp should be equal to BasePropClient     ";
      }
      if (errors !== "") {
        setSending(false);
        setLabel("Error");
        seterrorbook((errorbook) => ({
          ...errorbook,
          open: true,
          desc: errors,
        }));
        if (newE) {
          toggleEvent();
        }
      } else {
        let Account = [];

        Account = [...custody];

        Account = Account.concat(account);

        Account = Account.concat(custodyProp);

        Account = Account.concat(accountProp);

        let corpevent = {
          Account,
        };

        corpevent.id = Corpevent.id;
        corpevent.AssetId = Corpevent.AssetId;
        corpevent.Date = Corpevent.Date;
        corpevent.name = Corpevent.name;
        corpevent.CorporateEventType = Corpevent.CorporateEventType;
        corpevent.CorporateEventSettlementCurrency = Corpevent.CorporateEventSettlementCurrency;
        corpevent.CorporateEventFX = Corpevent.CorporateEventFX;
        corpevent.CorporateEventCommissionCurrency = Corpevent.CorporateEventCommissionCurrency;
        corpevent.CorporateEventCommissionFX = Corpevent.CorporateEventCommissionFX;
        corpevent.CorporateEventTaxFX = Corpevent.CorporateEventTaxFX;
        corpevent.CorporateEventTaxCurrency = Corpevent.CorporateEventTaxCurrency;
        corpevent.CorporateEventClientTaxFX = Corpevent.CorporateEventClientTaxFX;
        corpevent.CorporateEventTaxPercentage = Corpevent.CorporateEventTaxPercentage;
        corpevent.BookDate = Corpevent.BookDate;
        corpevent.RecordDate = Corpevent.RecordDate;
        corpevent.CorporateEventWithholdingP = Corpevent.CorporateEventWithholdingP;
        corpevent.CorporateEventReleased = Corpevent.CorporateEventReleased;

        for (var j = 0; j < corpevent.Account.length; j++) {
          let FootPrint = [];
          if (Account[j].FootPrintCredit != undefined) {
            FootPrint = [...Account[j].FootPrintCredit];
            if (Account[j].FootPrintDebit != undefined)
              FootPrint = FootPrint.concat(Account[j].FootPrintDebit);
          } else if (Account[j].FootPrintDebit != undefined) FootPrint = [...Account[j].FootPrintDebit];
          corpevent.Account[j].Footprint = FootPrint;
        }

        services.fetchRecalculateEvent({ corpevent }).then((re) => {
          services
            .fetchGetCorporateEventSingle({
              corporateeventid: props.event.CorporateEventId,
            })
            .then((r) => {
              setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));
              let custodyProp1 = r.Account.filter((account) => account.IsProp);
              let custody1 = r.Account.filter((account) => !account.IsProp);
              let account1 = r.Account.filter((account) => !account.IsProp);
              let accountProp1 = r.Account.filter((account) => account.IsProp);

              let custodyProp = custodyProp1.filter((item) => item.BasicAccountType == "Bank");
              let custody = custody1.filter((item) => item.BasicAccountType == "Bank");
              let account = account1.filter((item) => item.BasicAccountType == "Customer");
              let accountProp = accountProp1.filter(
                (item) => item.BasicAccountType == "InBalance" || item.BasicAccountType == "Fund"
              );
              setCustody(custody);
              setCustodyProp(custodyProp);
              setAccount(account);
              setAccountProp(accountProp);
              setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));

              seterrorbook((errorbook) => ({
                ...errorbook,
                open: false,
                desc: "",
              }));

              let errors = "";

              if (Number(Corpevent.WithholdingNoProp) - Number(Corpevent.WithholdingNoPropClient) > 5) {
                errors += "WithholdingNoProp should be equal to WithholdingNoPropClient    ";
              }
              if (Number(Corpevent.WithholdingProp) - Number(Corpevent.WithholdingPropClient) > 5) {
                errors += "WithholdingProp should be equal to WithholdingPropClient    ";
              }
              if (Number(Corpevent.BaseNoProp) - Number(Corpevent.BaseNoPropClient) > 5) {
                errors += "BaseNoProp should be equal to BaseNoPropClient     ";
              }
              if (Number(Corpevent.BaseProp) - Number(Corpevent.BasePropClient) > 5) {
                errors += "BaseProp should be equal to BasePropClient     ";
              }
              if (errors !== "") {
                setSending(false);
                seterrorbook((errorbook) => ({
                  ...errorbook,
                  open: true,
                  desc: errors,
                }));
                if (newE) {
                  toggleEvent();
                }
              } else {
                services
                  .fetchExecuteIntEvent({ corporateeventid: Corpevent.id, waitresponse: false })
                  .then((re) => {
                    setSending(false);
                    if (re.result.Code == 400 && re.e) {
                      seterrorbook((errorbook) => ({
                        ...errorbook,
                        open: true,
                        desc: re.result.Description,
                      }));
                    } else {
                      setSending(false);
                      showToast(
                        "Corporate event execution started in the background with state 'On Validate'."
                      );
                      searchEvents();
                      toggle();
                      if (newE) {
                        toggleEvent();
                      }
                    }
                  });
              }
            });
        });
      }
    } else {
      let Account = [];

      Account = [...custody];

      Account = Account.concat(account);

      Account = Account.concat(custodyProp);

      Account = Account.concat(accountProp);

      let corpevent = {
        Account,
      };

      corpevent.id = Corpevent.id;
      corpevent.AssetId = Corpevent.AssetId;
      corpevent.Date = Corpevent.Date;
      corpevent.name = Corpevent.name;
      corpevent.CorporateEventType = Corpevent.CorporateEventType;
      corpevent.CorporateEventSettlementCurrency = Corpevent.CorporateEventSettlementCurrency;
      corpevent.CorporateEventFX = Corpevent.CorporateEventFX;
      corpevent.CorporateEventCommissionCurrency = Corpevent.CorporateEventCommissionCurrency;
      corpevent.CorporateEventCommissionFX = Corpevent.CorporateEventCommissionFX;
      corpevent.CorporateEventTaxFX = Corpevent.CorporateEventTaxFX;
      corpevent.CorporateEventTaxCurrency = Corpevent.CorporateEventTaxCurrency;
      corpevent.CorporateEventClientTaxFX = Corpevent.CorporateEventClientTaxFX;
      corpevent.CorporateEventTaxPercentage = Corpevent.CorporateEventTaxPercentage;
      corpevent.BookDate = Corpevent.BookDate;
      corpevent.RecordDate = Corpevent.RecordDate;
      corpevent.CorporateEventWithholdingP = Corpevent.CorporateEventWithholdingP;
      corpevent.CorporateEventReleased = Corpevent.CorporateEventReleased;

      for (var j = 0; j < corpevent.Account.length; j++) {
        let FootPrint = [];
        if (Account[j].FootPrintCredit != undefined) {
          FootPrint = [...Account[j].FootPrintCredit];
          if (Account[j].FootPrintDebit != undefined) FootPrint = FootPrint.concat(Account[j].FootPrintDebit);
        } else if (Account[j].FootPrintDebit != undefined) FootPrint = [...Account[j].FootPrintDebit];
        corpevent.Account[j].Footprint = FootPrint;
      }

      services.fetchRecalculateEvent({ corpevent }).then((re) => {
        services
          .fetchGetCorporateEventSingle({
            corporateeventid: props.event.CorporateEventId,
          })
          .then((r) => {
            setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));
            let custodyProp1 = r.Account.filter((account) => account.IsProp);
            let custody1 = r.Account.filter((account) => !account.IsProp);
            let account1 = r.Account.filter((account) => !account.IsProp);
            let accountProp1 = r.Account.filter((account) => account.IsProp);

            let custodyProp = custodyProp1.filter((item) => item.BasicAccountType == "Bank");
            let custody = custody1.filter((item) => item.BasicAccountType == "Bank");
            let account = account1.filter((item) => item.BasicAccountType == "Customer");
            let accountProp = accountProp1.filter(
              (item) => item.BasicAccountType == "InBalance" || item.BasicAccountType == "Fund"
            );
            setCustody(custody);
            setCustodyProp(custodyProp);
            setAccount(account);
            setAccountProp(accountProp);
            setEvent((oldState) => ({ ...r, BookDate: oldState.BookDate }));

            seterrorbook((errorbook) => ({
              ...errorbook,
              open: false,
              desc: "",
            }));

            let errors = "";

            if (Number(Corpevent.WithholdingNoProp) - Number(Corpevent.WithholdingNoPropClient) > 5) {
              errors += "WithholdingNoProp should be equal to WithholdingNoPropClient    ";
            }
            if (Number(Corpevent.WithholdingProp) - Number(Corpevent.WithholdingPropClient) > 5) {
              errors += "WithholdingProp should be equal to WithholdingPropClient    ";
            }
            if (Number(Corpevent.BaseNoProp) - Number(Corpevent.BaseNoPropClient) > 5) {
              errors += "BaseNoProp should be equal to BaseNoPropClient     ";
            }
            if (Number(Corpevent.BaseProp) - Number(Corpevent.BasePropClient) > 5) {
              errors += "BaseProp should be equal to BasePropClient     ";
            }
            if (errors !== "") {
              setSending(false);
              seterrorbook((errorbook) => ({
                ...errorbook,
                open: true,
                desc: errors,
              }));
              if (newE) {
                toggleEvent();
              }
            } else {
              services
                .fetchExecuteIntEvent({ corporateeventid: Corpevent.id, waitresponse: false })
                .then((re) => {
                  setSending(false);
                  if (re.result.Code == 400) {
                    seterrorbook((errorbook) => ({
                      ...errorbook,
                      open: true,
                      desc: re.result.Description,
                    }));
                  } else {
                    setSending(false);
                    showToast(
                      "Corporate event execution started in the background with state 'On Validate'."
                    );
                    searchEvents();
                    toggle();
                    if (newE) {
                      toggleEvent();
                    }
                  }
                });
            }
          });
      });
    }
  };

  const updateTruncate = () => {
    setSaving(true);
    const id = Corpevent.id || (Corpevent.CorporateEventAccount && Corpevent.CorporateEventAccount.id);
    const truncateValue = Corpevent.EventCheckTruncate;

    services.fetchUpdateTruncateCorporateEvent({ CorporateEventId: id, checkTruncate: truncateValue }).then((re) => {
      if (re.result.Code === 200) {
        setLabel("");
        seterrorbook((errorbook) => ({
          ...errorbook,
          open: true,
          desc: "Corporate event saved",
        }));
      } else {
        seterrorbook((errorbook) => ({
          ...errorbook,
          open: true,
          desc: re.desc,
        }));
      }

      setSaving(false);
    });

};

  const sendEvent = () => {
    setSending(true);
    recalculateBeforeSend();
  };

  const saveEvent = () => {
    setSaving(true);
    let error = "";

    let Account = [];

    Account = [...custody];

    Account = Account.concat(account);

    Account = Account.concat(custodyProp);

    Account = Account.concat(accountProp);

    let corpevent = {
      Account,
    };

    if (Account == null || Account.length == 0) error = "Add some " + translate("Account") + "s";

    for (var j = 0; j < corpevent.Account.length; j++) {
      if (!Account[j].BasicAccountId) error = "Select all " + translate("Account") + "s";
      else {
        let FootPrint = [];
        if (Account[j].FootPrintCredit != undefined) {
          FootPrint = [...Account[j].FootPrintCredit];
          if (Account[j].FootPrintDebit != undefined) FootPrint = FootPrint.concat(Account[j].FootPrintDebit);
        } else if (Account[j].FootPrintDebit != undefined) FootPrint = [...Account[j].FootPrintDebit];
        corpevent.Account[j].Footprint = FootPrint;
      }
    }

    if (error == "") {
      corpevent.id = Corpevent.id;
      corpevent.AssetId = Corpevent.AssetId;
      corpevent.Date = Corpevent.Date;
      corpevent.name = Corpevent.name;
      corpevent.CorporateEventType = Corpevent.CorporateEventType;
      corpevent.CorporateEventSettlementCurrency = Corpevent.CorporateEventSettlementCurrency;
      corpevent.CorporateEventFX = Corpevent.CorporateEventFX;
      corpevent.CorporateEventCommissionCurrency = Corpevent.CorporateEventCommissionCurrency;
      corpevent.CorporateEventCommissionFX = Corpevent.CorporateEventCommissionFX;
      corpevent.CorporateEventTaxFX = Corpevent.CorporateEventTaxFX;
      corpevent.CorporateEventTaxCurrency = Corpevent.CorporateEventTaxCurrency;
      corpevent.CorporateEventClientTaxFX = Corpevent.CorporateEventClientTaxFX;
      corpevent.CorporateEventTaxPercentage = Corpevent.CorporateEventTaxPercentage;
      corpevent.BookDate = Corpevent.BookDate;
      corpevent.RecordDate = Corpevent.RecordDate;
      corpevent.CorporateEventWithholdingP = Corpevent.CorporateEventWithholdingP;
      corpevent.CorporateEventReleased = Corpevent.CorporateEventReleased;
      corpevent.EventCheckTruncate = Corpevent.EventCheckTruncate;

      services.fetchRecalculateEvent({ corpevent }).then((re) => {
        if (re.result.Code === 200) {
          setLabel("");
          seterrorbook((errorbook) => ({
            ...errorbook,
            open: true,
            desc: "Corporate event saved",
          }));
        } else {
          seterrorbook((errorbook) => ({
            ...errorbook,
            open: true,
            desc: re.desc,
          }));
        }

        setSaving(false);
      });
    } else {
      seterrorbook((errorbook) => ({
        ...errorbook,
        open: true,
        desc: error,
      }));
      setSaving(false);
    }
  };

  const removeCustody = (accounts, propia, type, index, accountid) => {
    let accountaux = [];
    let indexCorp = 0;
    let remove = {};

    indexCorp = Corpevent.Account.indexOf(accountid);
    Corpevent.Account.splice(indexCorp, 1);

    if (type === "Customer") {
      if (propia) {
        //Corpevent.Account = Corpevent.Account.concat(paracambiar)
        accountaux = [...accountProp];
        remove = accountaux.splice(index, 1);
        for (var j = 0; j < remove[0].FootPrintDebit.length; j++) {
          onChangeGrid("Debit", "Client", propia, index, j, 0);
        }

        for (var j = 0; j < remove[0].FootPrintCredit.length; j++) {
          onChangeGrid("Credit", "Client", propia, index, j, 0);
        }
        onChangeGrid("EventAccountAmount", "Client", propia, index, 0, 0);
        setAccountProp(accountaux);
      } else {
        accountaux = [...account];
        remove = accountaux.splice(index, 1);

        for (var j = 0; j < remove[0].FootPrintDebit.length; j++) {
          onChangeGrid("Debit", "Client", propia, index, j, 0);
        }

        for (var j = 0; j < remove[0].FootPrintCredit.length; j++) {
          onChangeGrid("Credit", "Client", propia, index, j, 0);
        }
        onChangeGrid("EventAccountAmount", "Client", propia, index, 0, 0);
        setAccount(accountaux);
      }
    } else {
      if (propia) {
        accountaux = [...custodyProp];
        remove = accountaux.splice(index, 1);

        for (var j = 0; j < remove[0].FootPrintDebit.length; j++) {
          onChangeGrid("Debit", "Custody", propia, index, j, 0);
        }

        for (var j = 0; j < remove[0].FootPrintCredit.length; j++) {
          onChangeGrid("Credit", "Custody", propia, index, j, 0);
        }
        onChangeGrid("EventAccountAmount", "Custody", propia, index, 0, 0);
        setCustodyProp(accountaux);
      } else {
        accountaux = [...custody];
        remove = accountaux.splice(index, 1);

        for (var j = 0; j < remove[0].FootPrintDebit.length; j++) {
          onChangeGrid("Debit", "Custody", propia, index, j, 0);
        }

        for (var j = 0; j < remove[0].FootPrintCredit.length; j++) {
          onChangeGrid("Credit", "Custody", propia, index, j, 0);
        }
        onChangeGrid("EventAccountAmount", "Custody", propia, index, 0, 0);
        setCustody(accountaux);
      }
    }
  };

  const addCustody = (accounts, propia, type) => {
    let accountaux = [];

    const defaultCustody = {
      BasicAccountId: 0,
      BasicAccountNumber: "",
      BasicAccountName: "",
      EventBalanceType: "Current",
      EventAccountAmount: "0.00000000",
      BasicAccountType: "Bank",
      EventAccountTaxImputability: "0.00000",
      IsProp: propia,
      Coldebit: 1,
      Colcredit: 4,
      FootPrintCredit: [
        {
          EventAccountFootprintId: "1",
          EventAccountDebitCredit: 1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsFee: true,
          EventAccountIsTax: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: false,
          Tooltip: "PYG Fee",
        },
        {
          EventAccountFootprintId: "2",
          EventAccountDebitCredit: 1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsFee: false,
          EventAccountIsTax: false,
          EventAccountIsWithholding: true,
          EventAccountBaseForTax: false,
          EventAccountModified: false,
          Tooltip: "PYG Withholding",
        },
        {
          EventAccountFootprintId: "3",
          EventAccountDebitCredit: 1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsFee: false,
          EventAccountIsTax: true,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: false,
          Tooltip: "PYG TAX (Calculated)",
        },
        {
          EventAccountFootprintId: "4",
          EventAccountDebitCredit: 1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: false,
          EventAccountSecurityId: "1",
          EventAccountTicker: "UYU TAX (Executed)",
          EventAccountIsCommission: false,
          EventAccountIsFee: false,
          EventAccountIsTax: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: false,
          Tooltip: "PYG TAX (Executed)",
        },
      ],
      FootPrintDebit: [
        {
          EventAccountFootprintId: "5",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "11219178.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsTax: false,
          EventAccountIsFee: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: true,
          EventAccountModified: false,
          Tooltip: "PYG",
        },
      ],
      EventCashCustAccountName: "New Custody Cash Account",
      EventCashCustAccountId: 0,
      added: true,
    };

    const defaultCustomer = {
      BasicAccountId: 0,
      BasicAccountNumber: "",
      BasicAccountName: "",
      EventBalanceType: "Current",
      EventAccountAmount: "100.00000000",
      BasicAccountType: "Customer",
      EventAccountTaxImputability: "100.00000",
      IsProp: propia,
      Coldebit: 5,
      Colcredit: 1,
      FootPrintCredit: [
        {
          EventAccountFootprintId: "1",
          EventAccountDebitCredit: 1,
          EventAccountDebitCreditVolume: "2817260.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsFee: false,
          EventAccountIsTax: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: true,
          EventAccountModified: true,
          Tooltip: "PYG",
        },
      ],
      FootPrintDebit: [
        {
          EventAccountFootprintId: "2",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: true,
          EventAccountIsTax: false,
          EventAccountIsFee: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: true,
          Tooltip: "PYG Commission",
        },
        {
          EventAccountFootprintId: "3",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsTax: false,
          EventAccountIsFee: false,
          EventAccountIsWithholding: true,
          EventAccountBaseForTax: false,
          EventAccountModified: true,
          Tooltip: "PYG Withholding",
        },
        {
          EventAccountFootprintId: "4",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsTax: true,
          EventAccountIsFee: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: true,
          Tooltip: "PYG TAX",
        },
        {
          EventAccountFootprintId: "0",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "100.00000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "0",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsTax: false,
          EventAccountIsFee: false,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: true,
          Tooltip: "Imputability",
        },
        {
          EventAccountFootprintId: "5",
          EventAccountDebitCredit: -1,
          EventAccountDebitCreditVolume: "0.00000000",
          EventAccountIsCurrency: true,
          EventAccountSecurityId: "1",
          EventAccountTicker: "PYG",
          EventAccountIsCommission: false,
          EventAccountIsTax: false,
          EventAccountIsFee: true,
          EventAccountIsWithholding: false,
          EventAccountBaseForTax: false,
          EventAccountModified: true,
          Tooltip: "PYG Fee",
        },
      ],
      added: true,
    };

    let item;

    if (type === "Custody") {
      item =
        custodyaux && Object.keys(custodyaux).length
          ? JSON.parse(JSON.stringify(custodyaux))
          : defaultCustody;

      if (propia) {
        Corpevent.Account = [...Corpevent.Account, item];
        accountaux = [...custodyProp, item];
        setCustodyProp(accountaux);
      } else {
        Corpevent.Account = [...Corpevent.Account, item];
        accountaux = [...custody, item];
        setCustody(accountaux);
      }
    }

    if (type === "Customer") {
      item =
        accountaux && Object.keys(accountaux).length
          ? JSON.parse(JSON.stringify(accountaux))
          : defaultCustomer;

      if (propia) {
        Corpevent.Account = [...Corpevent.Account, item];
        accountaux = [...accountProp, item];
        setAccountProp(accountaux);
      } else {
        Corpevent.Account = [...Corpevent.Account, item];
        accountaux = [...account, item];
        setAccount(accountaux);
      }
    }
  };

  function downloadExcel() {
    let sheetCustody = [];

    sheetCustody = [...custody];

    sheetCustody = sheetCustody.concat(custodyProp);

    let sheetClient = [];

    sheetClient = sheetClient.concat(account);

    sheetClient = sheetClient.concat(accountProp);

    const data = {
      custodyTotal: [...sheetCustody],
      clientTotal: [...sheetClient],
    };

    const camelCase = (str) => {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    };

    const filterColumns = (data) => {
      // Get column names
      const columns = Object.keys(data.clientTotal[0]);

      // Remove by key (firstname)
      const filterColsByKey = columns.shift();

      return filterColsByKey; 
    };

    return (
      <div className="App">
        <ExcelFile filename="test">
          <ExcelSheet data={data.clientTotal} name="Test">
            {filterColumns(data).map((col) => {
              return <ExcelColumn label={camelCase(col)} value={col} />;
            })}
          </ExcelSheet>
        </ExcelFile>
        <table id="table-to-xls">
          <thead>
            <tr>
              <th>AccountNumber</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <tr>
                  <td>{item.BasicAccountId}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const concatData = async () => {
    setdownloading(true);
    let client = [];

    client = [...account];

    client = client.concat(accountProp);

    let custodies = [];

    custodies = [...custodyProp];

    custodies = custodies.concat(custody);

    let clientdata = [];

    for (var j = 0; j < client.length; j++) {
      let item = {};
      item = {
        account: client[j].BasicAccountNumber,
        accountPortfolio: client[j].EventAccountAmount,
      };

      let Footprints = client[j].FootPrintCredit;
      for (var i = 0; i < Footprints.length; i++) {
        let name = Footprints[i].Tooltip;
        let rounded = Number(4);
        if (Footprints[i].EventAccountIsCurrency === true) rounded = Number(2);
        item = {
          ...item,
          [name]: Number(Number(Footprints[i].EventAccountDebitCreditVolume).toFixed(rounded)),
        };
      }
      let Footprints2 = client[j].FootPrintDebit;
      for (var i = 0; i < Footprints2.length; i++) {
        let name = Footprints2[i].Tooltip;
        let rounded = Number(4);
        if (Footprints2[i].EventAccountIsCurrency === true) rounded = Number(2);
        item = {
          ...item,
          [name]: Number(Number(Footprints2[i].EventAccountDebitCreditVolume).toFixed(rounded)),
        };
      }
      clientdata.push(item);
    }

    let custodydata = [];

    for (var j = 0; j < custodies.length; j++) {
      let item = {};
      item = {
        account: custodies[j].BasicAccountName,
        accountPortfolio: custodies[j].EventAccountAmount,
      };
      let Footprints = custodies[j].FootPrintCredit;
      for (var i = 0; i < Footprints.length; i++) {
        let name = Footprints[i].Tooltip;
        let rounded = Number(4);
        if (Footprints[i].EventAccountIsCurrency === true) rounded = Number(2);
        item = {
          ...item,
          [name]: Number(Number(Footprints[i].EventAccountDebitCreditVolume).toFixed(rounded)),
        };
      }
      let Footprints2 = custodies[j].FootPrintDebit;
      for (var i = 0; i < Footprints2.length; i++) {
        let name = Footprints2[i].Tooltip;
        let rounded = Number(4);
        if (Footprints2[i].EventAccountIsCurrency === true) rounded = Number(2);
        item = {
          ...item,
          [name]: Number(Number(Footprints2[i].EventAccountDebitCreditVolume).toFixed(rounded)),
        };
      }
      custodydata.push(item);
    }

    let header = [];

    let headeritem = {
      book: Corpevent.BookDate,
      date: Corpevent.Date,
      record: Corpevent.RecordDate,
      asset: Corpevent.AssetTicker,
      isin: Corpevent.AssetIsin,
      event: Corpevent.CorporateEventType,
      settcurrency: Corpevent.CorporateEventSettlementCurrencyISO,
      settcurrencyfx: Corpevent.CorporateEventFX,
      commcurrency: Corpevent.CorporateEventCommissionCurrencyISO,
      commcurrencyfx: Corpevent.CorporateEventCommissionFX,
      taxcurrency: Corpevent.CorporateEventTaxCurrencyISO,
      taxcurrencyfx: Corpevent.CorporateEventTaxFX,
    };

    header.push(headeritem);
    header.push({});

    let response = undefined;
    let body = {
      id: Corpevent.id,
      clients: clientdata,
      custody: custodydata,
      header: headeritem,
    };

    await services
      .corporateEventXLSX(body)
      .then((r) => {
        if (r.response.count > 0) {
          response = r.response.buffer.data;

          try {
            const blob = new Blob([new Uint8Array(response)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "CorporateEvent" + String(Corpevent.id) + ".xlsx";
            link.click();
            setdownloading(false);
          } catch (ex) {}
        }
      })
      .catch((e) => {});
    //setReportResponse(response);
  };

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle}>Corporate Event</ModalHeader>
      <ModalBody className={style.body}>
        <div className={style.form}>
          <Container>
            {errorbook.open ? (
              <Errors toggle={toggle} label={label} bookerror={errorbook}></Errors>
            ) : (
              <div></div>
            )}
            {Corpevent.CorporateEventWarning && Corpevent.CorporateEventWarning.length > 0 && (
              <Row>
                <Col>
                  <mark
                    class="fa fa-exclamation-triangle"
                    aria-hidden="true"
                    font-weight="bold"
                    background-color="yellow"
                    color="black"
                  >
                    There are some warnings, if it's important, create the event again.
                  </mark>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>{translate("Account")}</th>
                        <th>Info</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Corpevent.CorporateEventWarning &&
                        Corpevent.CorporateEventWarning.map((rep) => {
                          return (
                            <tr>
                              <td>{rep.key}</td>
                              <td>{rep.value}</td>
                              <td>{rep.description}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            )}

            <Row>
              <Col xs={6} lg={6}>
                <Row className={style.table}>
                  <Col style={{ zIndex: "1", position: "inherit" }}>
                    <Field label={"Book date"}>
                      <DateField
                        label=""
                        name="BookDate"
                        onChange={(name, value) => onChange(name, value)}
                        value={parseDate(Corpevent.BookDate)}
                      />
                    </Field>

                    <Field label={"Record date"}>
                      <DateField
                        label=""
                        name="RecordDate"
                        onChange={(name, value) => onChange(name, value)}
                        disabled={true}
                        value={parseDate(Corpevent.RecordDate)}
                      />
                    </Field>

                    <Field label={"Event date"}>
                      <DateField
                        label=""
                        name="Date"
                        onChange={(name, value) => onChange(name, value)}
                        disabled={true}
                        value={parseDate(Corpevent.Date)}
                      />
                    </Field>

                    {Corpevent.CorporateEventType == "Coupon" && (
                      <Field label={"Coupon Number"}>
                        <Input
                          value={Corpevent.CouponNumber}
                          placeholder={"Coupon Number"}
                          disabled={Corpevent.CouponNumber != 0}
                        />
                      </Field>
                    )}
                  </Col>

                  <Col>
                    <Field label={"Event Type"}>
                      <Input
                        value={Corpevent.CorporateEventType}
                        placeholder={"Event Type"}
                        disabled={true}
                      />
                    </Field>

                    <Field label={"Asset"}>
                      <Input value={Corpevent.AssetTicker} placeholder={"Asset"} disabled={true} />
                    </Field>

                    <Field label={"ISIN"}>
                      <Input value={Corpevent.AssetIsin} placeholder={"ISIN"} disabled={true} />
                    </Field>

                    <Field label={"Status"}>
                      <Input value={Corpevent.Status} placeholder={"Status"} disabled={true} />
                    </Field>
                  </Col>
                </Row>
              </Col>

              <Col xs={6} lg={6}>
                <Row className={style.table}>
                  <Col>
                    <Field label={"Settlement Currency"}>
                      {currencies == undefined ? (
                        <div></div>
                      ) : currencies.length == 0 ? (
                        <div></div>
                      ) : (
                        <Combobox
                          items={currencies}
                          value={Corpevent.CorporateEventSettlementCurrency}
                          name={"CorporateEventSettlementCurrency"}
                          onChange={(v) => onChangeCurrency("CorporateEventSettlementCurrency", v)}
                        />
                      )}
                    </Field>

                    <Field label={"Commission Currency"}>
                      {currencies == undefined ? (
                        <div></div>
                      ) : currencies.length == 0 ? (
                        <div></div>
                      ) : (
                        <Combobox
                          items={currencies}
                          value={Corpevent.CorporateEventCommissionCurrency}
                          name={"CorporateEventCommissionCurrency"}
                          onChange={(v) => onChangeCurrency("CorporateEventCommissionCurrency", v)}
                        />
                      )}
                    </Field>

                    <Field label={"Tax Currency"}>
                      {currencies == undefined ? (
                        <div></div>
                      ) : currencies.length == 0 ? (
                        <div></div>
                      ) : (
                        <Combobox
                          items={currencies}
                          value={Corpevent.CorporateEventTaxCurrency}
                          name={"CorporateEventTaxCurrency"}
                          onChange={(v) => onChangeCurrency("CorporateEventTaxCurrency", v)}
                        />
                      )}
                    </Field>
                  </Col>

                  <Col>
                    <Field label={"FX" + " " + currencypairs.labelsett}>
                      <Numeric
                        value={Corpevent.CorporateEventFX}
                        placeholder={"FX"}
                        onChange={(v) => onChange("CorporateEventFX", v)}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"FX" + " " + currencypairs.labelcomm}>
                      <Numeric
                        value={Corpevent.CorporateEventCommissionFX}
                        placeholder={"FX"}
                        onChange={(v) => onChange("CorporateEventCommissionFX", v)}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"FX" + " " + currencypairs.labeltax}>
                      <Numeric
                        value={Corpevent.CorporateEventTaxFX}
                        placeholder={"FX"}
                        onChange={(v) => onChange("CorporateEventTaxFX", v)}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Client FX" + " " + currencypairs.labeltax}>
                      <Numeric
                        value={Corpevent.CorporateEventClientTaxFX}
                        placeholder={"FX"}
                        onChange={(v) => onChange("CorporateEventClientTaxFX", v)}
                        dataTypeDecimalName="currency"
                      />
                    </Field>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xs={6} lg={6}>
                <Field label={"Description"}>
                  <Input
                    type="text"
                    value={Corpevent.name}
                    placeholder={"Description"}
                    onChange={(v) => onChange("name", v.target.value)}
                  />
                </Field>
              </Col>
              <Col xs={2} lg={2}>
                <Field label={"Asset Currency"}>
                  <Input
                    value={Corpevent.CurrencyISO}
                    placeholder={"Asset Currency"}
                    disabled={true}
                  />
                </Field>
              </Col>
              <Col xs={2} lg={2} style={{ display: 'flex', alignItems: 'center', paddingTop: '25px' }}>
                  <strong style={{ marginRight: '10px' }}>Release</strong>
                  <Input
                    type="checkbox"
                    className="switch-input"
                    onChange={(v) => onChange("CorporateEventReleased", !Corpevent.CorporateEventReleased)}
                    checked={!!Corpevent.CorporateEventReleased}
                    disabled={isReadOnly || Corpevent.CorporateEventReleased}
                  />
                </Col>
                <Col xs={2} lg={2} style={{ display: 'flex', alignItems: 'center', paddingTop: '25px' }}>
                  <strong style={{ marginRight: '10px' }}>Truncate</strong>
                  <Input
                    type="checkbox"
                    className="switch-input"
                    checked={
                      Corpevent.CorporateEventAccount 
                        ? !!Corpevent.CorporateEventAccount.EventCheckTruncate 
                        : !!Corpevent.EventCheckTruncate
                    }
                    onChange={() => {
                      const valorActual = Corpevent.CorporateEventAccount 
                        ? Corpevent.CorporateEventAccount.EventCheckTruncate 
                        : Corpevent.EventCheckTruncate;
                      onChange("EventCheckTruncate", !valorActual);
                    }}
                    disabled={
                      isReadOnly || (Corpevent.CorporateEventAccount 
                        ? Corpevent.CorporateEventAccount.EventCheckTruncate 
                        : Corpevent.EventCheckTruncate)
                    }
                  />
                </Col>
              <Col xs={3} lg={3}>
                <Field label={"Release"}>
                  <Row style={{ paddingLeft: 50 }}>
                    <Input
                      type="checkbox"
                      className="switch-input"
                      onChange={(v) => onChange("CorporateEventReleased", !Corpevent.CorporateEventReleased)}
                      value={Corpevent.CorporateEventReleased}
                      disabled={isReadOnly || Corpevent.CorporateEventReleased}
                    />
                  </Row>
                </Field>
              </Col>
            </Row>

            <Card>
              <CardHeader>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      active={wizzard === 1}
                      onClick={
                        Corpevent.Status == "Initiated" &&
                        !Corpevent.CorporateEventReleased &&
                        ChangesValuesInClients
                          ? () => {
                              recalculate(1);
                              setChangesValuesInClients(false);
                              setLastUpdatedFrom("clients");
                              setFirstChangeClients(true);
                              setFirstChangeCustodians(false);
                              setOriginalClientsValues({
                                BaseNoProp: Corpevent.BaseNoProp,
                                BaseProp: Corpevent.BaseProp,
                                CorporateEventFX: Corpevent.CorporateEventFX,
                                CorporateEventCommissionFX: Corpevent.CorporateEventCommissionFX,
                                CorporateEventTaxFX: Corpevent.CorporateEventTaxFX,
                                CorporateEventClientTaxFX: Corpevent.CorporateEventClientTaxFX,
                                CorporateEventSettlementCurrency: Corpevent.CorporateEventSettlementCurrency,
                                CorporateEventCommissionCurrency: Corpevent.CorporateEventCommissionCurrency,
                                CorporateEventTaxCurrency: Corpevent.CorporateEventTaxCurrency,
                                WithholdingNoProp: Corpevent.WithholdingNoProp,
                                WithholdingProp: Corpevent.WithholdingProp,
                                FeeNoProp: Corpevent.FeeNoProp,
                                FeeProp: Corpevent.FeeProp,
                                TaxNoProp: Corpevent.TaxNoProp,
                                TaxProp: Corpevent.TaxProp,
                                BookDate: Corpevent.BookDate,
                                CommissionNoPropClient: Corpevent.CommissionNoPropClient,
                                CommissionProp: Corpevent.CommissionProp,
                              });
                            }
                          : () => setWizzard(1)
                      }
                    >
                      <i className="fa fa-university" /> Custodians
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={wizzard === 2}
                      onClick={
                        Corpevent.Status == "Initiated" &&
                        !Corpevent.CorporateEventReleased &&
                        ChangesValuesInCustodians
                          ? () => {
                              recalculate(2);
                              setChangesValuesInCustodians(false);
                              setLastUpdatedFrom("custodians");
                              setFirstChangeCustodians(true);
                              setFirstChangeClients(false);
                              setOriginalCustodiansValues({
                                BaseNoProp: Corpevent.BaseNoProp,
                                BaseProp: Corpevent.BaseProp,
                                CorporateEventFX: Corpevent.CorporateEventFX,
                                CorporateEventCommissionFX: Corpevent.CorporateEventCommissionFX,
                                CorporateEventTaxFX: Corpevent.CorporateEventTaxFX,
                                CorporateEventClientTaxFX: Corpevent.CorporateEventClientTaxFX,
                                CorporateEventSettlementCurrency: Corpevent.CorporateEventSettlementCurrency,
                                CorporateEventCommissionCurrency: Corpevent.CorporateEventCommissionCurrency,
                                CorporateEventTaxCurrency: Corpevent.CorporateEventTaxCurrency,
                                WithholdingNoProp: Corpevent.WithholdingNoProp,
                                WithholdingProp: Corpevent.WithholdingProp,
                                FeeNoProp: Corpevent.FeeNoProp,
                                FeeProp: Corpevent.FeeProp,
                                TaxNoProp: Corpevent.TaxNoProp,
                                TaxProp: Corpevent.TaxProp,
                                BookDate: Corpevent.BookDate,
                                CommissionNoPropClient: Corpevent.CommissionNoPropClient,
                                CommissionProp: Corpevent.CommissionProp,
                              });
                            }
                          : () => setWizzard(2)
                      }
                    >
                      <i className="fa fa-user" /> Clients
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                {wizzard === 1 && !loading && (
                  <Row>
                    <Col xs={12} lg={12}>
                      <GridCustody
                        custody={custodyProp}
                        propia={true}
                        onChange={onChangeGrid}
                        fetchSearchAccount={services.fetchSearchBankProp}
                        readOnly={isReadOnly || !Corpevent.CorporateEventReleased || Corpevent.Status === "Executed"}
                        addCustody={addCustody}
                        removeCustody={removeCustody}
                        isFundsXSystem={isFundsXSystem}
                      />
                    </Col>
                    <Col xs={12} lg={12}>
                      <GridCustody
                        custody={custody}
                        propia={false}
                        onChange={onChangeGrid}
                        fetchSearchAccount={services.fetchSearchBank}
                        readOnly={isReadOnly || !Corpevent.CorporateEventReleased || Corpevent.Status === "Executed"}
                        addCustody={addCustody}
                        removeCustody={removeCustody}
                        isFundsXSystem={isFundsXSystem}
                      />
                    </Col>
                  </Row>
                )}
                {wizzard === 2 && !loading && (
                  <Row>
                    <Col xs={12} lg={12}>
                      <GridAccount
                        account={accountProp}
                        propia={true}
                        onChange={onChangeGrid}
                        fetchSearchAccount={services.fetchSearchAccountProp}
                        readOnly={isReadOnly || !Corpevent.CorporateEventReleased || Corpevent.Status === "Executed"}
                        addCustody={addCustody}
                        removeCustody={removeCustody}
                        isFundsXSystem={isFundsXSystem}
                      />
                    </Col>

                    <Col xs={12} lg={12}>
                      <GridAccount
                        account={account}
                        propia={false}
                        onChange={onChangeGrid}
                        readOnly={isReadOnly || !Corpevent.CorporateEventReleased || Corpevent.Status === "Executed"}
                        fetchSearchAccount={services.fetchSearchAccount}
                        addCustody={addCustody}
                        removeCustody={removeCustody}
                        isFundsXSystem={isFundsXSystem}
                      />
                    </Col>
                  </Row>
                )}
                {loading && <EmptyTable load={loading} />}
              </CardBody>
            </Card>

            <Row>
              <Col>
                <Field label={"Totals"}></Field>
              </Col>
            </Row>

            <Row>
              <Col xs={6} lg={6}>
                <Row className={style.table}>
                  <Col xs={6} lg={6}>
                    <Field label={isFundsXSystem ? "Funds Custodians" : "Prop Custodians"}></Field>
                    <Field label={"Portfolio"}>
                      <Numeric
                        value={Corpevent.PortfolioTotalProp}
                        placeholder={"Portfolio"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Base For Tax"}>
                      <Numeric
                        value={Corpevent.BaseProp}
                        placeholder={"Base For Tax"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Withholding"}>
                      <Numeric
                        value={Corpevent.WithholdingProp}
                        placeholder={"Withholding"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Fee"}>
                      <Numeric
                        value={Corpevent.FeeProp}
                        placeholder={"Fee"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>
                    <Field label={"Tax"}>
                      <Numeric
                        value={Corpevent.TaxProp}
                        placeholder={"Tax"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>
                  </Col>

                  <Col>
                    <Field label={isFundsXSystem ? "Funds" : "Prop Clients"}></Field>
                    <Field label={"Portfolio"}>
                      <Numeric
                        value={Corpevent.PortfolioTotalPropClient}
                        placeholder={"Portfolio"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Base For Tax"}>
                      <Numeric
                        value={Corpevent.BasePropClient}
                        placeholder={"Base For Tax"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Withholding"}>
                      <Numeric
                        value={Corpevent.WithholdingPropClient}
                        placeholder={"Withholding"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Fee"}>
                      <Numeric
                        value={Corpevent.FeePropClient}
                        placeholder={"Fee"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>

                    <Field label={"Tax"}>
                      <Numeric
                        value={Corpevent.TaxPropClient}
                        placeholder={"Tax"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>

                    <Field label={"Commissions"}>
                      <Numeric
                        value={Corpevent.CommissionPropClient}
                        placeholder={"Commissions"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>
                  </Col>
                </Row>
              </Col>

              <Col xs={6} lg={6}>
                <Row className={style.table}>
                  <Col>
                    <Field label={"Custodians"}></Field>
                    <Field label={"Portfolio Total"}>
                      <Numeric
                        value={Corpevent.PortfolioTotalNoProp}
                        placeholder={"Portfolio Total"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Base for Tax"}>
                      <Numeric
                        value={Corpevent.BaseNoProp}
                        placeholder={"Base for Tax"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Withholding"}>
                      <Numeric
                        value={Corpevent.WithholdingNoProp}
                        placeholder={"Withholding"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Fee"}>
                      <Numeric
                        value={Corpevent.FeeNoProp}
                        placeholder={"Fee"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>
                    <Field label={"Tax"}>
                      <Numeric
                        value={Corpevent.TaxNoProp}
                        placeholder={"Tax"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>
                  </Col>

                  <Col>
                    <Field label={"Clients"}></Field>
                    <Field label={"Portfolio Total"}>
                      <Numeric
                        value={Corpevent.PortfolioTotalNoPropClient}
                        placeholder={"Portfolio Total"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Base for Tax"}>
                      <Numeric
                        value={Corpevent.BaseNoPropClient}
                        placeholder={"Base for Tax"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Withholding"}>
                      <Numeric
                        value={Corpevent.WithholdingNoPropClient}
                        placeholder={"Withholding"}
                        disabled={true}
                        dataTypeDecimalName="currency"
                      />
                    </Field>

                    <Field label={"Fee"}>
                      <Numeric
                        value={Corpevent.FeeNoPropClient}
                        placeholder={"Fee"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>

                    <Field label={"Tax"}>
                      <Numeric
                        value={Corpevent.TaxNoPropClient}
                        placeholder={"Tax"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>

                    <Field label={"Commissions"}>
                      <Numeric
                        value={Corpevent.CommissionNoPropClient}
                        placeholder={"Commissions"}
                        dataTypeDecimalName="currency"
                        disabled={true}
                      />
                    </Field>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </ModalBody>
      <ModalFooter>
        <LaddaButton
          className="btn btn-ladda btn-primary ml-2 mr-2"
          loading={downloading}
          disabled={false}
          onClick={() => concatData()}
          data-style={EXPAND_RIGHT}
        >
          <i className="fa fa-download"></i>
        </LaddaButton>
        {!isReadOnly && Corpevent.Status == "Initiated" ? (
          <LaddaButton
            onClick={() => deleteEvent()}
            className="btn btn-ladda btn-primary"
            loading={deleting}
            disabled={false}
            data-style={EXPAND_RIGHT}
          >
            {"Delete"}
          </LaddaButton>
        ) : (
          <div></div>
        )}

        {!isReadOnly && Corpevent.Status == "Initiated" && Corpevent.CorporateEventReleased ? (
          <LaddaButton
            onClick={() => saveEvent()}
            className="btn btn-ladda btn-primary"
            loading={saving}
            disabled={false}
            data-style={EXPAND_RIGHT}
          >
            {"Save"}
          </LaddaButton>
        ) : (
          <div></div>
        )}

        {isReadOnly ? (
          <Button onClick={() => toggle()}>Close</Button>
        ) : Corpevent.Status == "Initiated" && !isReviewer ? (
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <LaddaButton
            onClick={() => sendEvent()}
            className="btn btn-ladda btn-primary"
            loading={sending}
            disabled={false}
            data-style={EXPAND_RIGHT}
          >
            {Corpevent.CorporateEventReleased ? "Book" : "Recalculate&Book"}
          </LaddaButton>
          <LaddaButton
          className="btn btn-ladda btn-primary"
          onClick={() => updateTruncate()}
          style={{ marginLeft: '8px' }}
          disabled={false}
          data-style={EXPAND_RIGHT}
        >
          Update
          </LaddaButton>
        </div>
        ) : (
          <Button onClick={() => toggle()}>Close</Button>
        )}
        {isEventReviewer && Corpevent.Status && Corpevent.Status.trim() === "Authorizing" && (
          <React.Fragment>
            <LaddaButton
              className="btn btn-ladda btn-primary ml-2"
              loading={sending}
              disabled={false}
              onClick={() => sendEvent()}
              data-style={EXPAND_RIGHT}
            >
              Book
            </LaddaButton>
            <LaddaButton
              className="btn btn-ladda btn-warning ml-2"
              loading={revertingStatus}
              disabled={false}
              onClick={() => setConfirmRevertOpen(true)}
              data-style={EXPAND_RIGHT}
            >
              Status Initiated
            </LaddaButton>
          </React.Fragment>
        )}
      </ModalFooter>
      {confirmRevertOpen && (
        <Modal isOpen={confirmRevertOpen} toggle={() => setConfirmRevertOpen(false)}>
          <ModalHeader toggle={() => setConfirmRevertOpen(false)}>
            Confirmation
          </ModalHeader>
          <ModalBody style={{ padding: '10px 8px' }}>
            <Container>
              <p>Are you sure you want to change the status back to Initiated?</p>
              <Input
                type="textarea"
                placeholder="Reason for reverting (optional)"
                value={revertText}
                onChange={(e) => setRevertText(e.target.value)}
                rows={3}
              />
            </Container>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col lg={6} style={{ textAlign: 'center' }}>
                <Button color="light" onClick={() => { setConfirmRevertOpen(false); setRevertText(""); }}>Close</Button>
              </Col>
              <Col lg={6} style={{ textAlign: 'center' }}>
                <LaddaButton
                  className="btn btn-ladda btn-primary"
                  loading={false}
                  disabled={revertingStatus}
                  onClick={() => {
                    setConfirmRevertOpen(false);
                    setRevertingStatus(true);
                    services.fetchChangeStatusCorporateEvents([Corpevent.id], "Initiated", revertText)
                      .then(() => {
                        setRevertingStatus(false);
                        setRevertText("");
                        searchEvents();
                        toggle();
                      })
                      .catch(() => {
                        setRevertingStatus(false);
                      });
                  }}
                  data-style={EXPAND_RIGHT}
                >
                  Confirm
                </LaddaButton>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      )}
    </Modal>
  );
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="10" style={{ textAlign: "center", padding: "100px" }}>
      <CircularProgress style={{ marginTop: "100%", textAlign: "center" }} />
    </td>
  </tr>
);

export default CorpEvents;
